import { Stack, Divider } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { WizardPage } from '../../../../general/components/wizard-page';
import { RootState } from '../../../../store';
import { DocsVerifyRevenueTile } from '../../components/docs-verify-revenue-tile/docs-verify-revenue-tile';
import { MxVerifyRevenueTile } from '../../components/mx-verify-revenue-tile/mx-verify-revenue-tile';

const selector = ({ bankAccountLinking: { revenueVerificationStatus } }: RootState) => ({
  revenueVerificationStatus,
});

const VerifyRevenuePage: FC = () => {
  const { revenueVerificationStatus } = useSelector(selector);
  const success = !revenueVerificationStatus || revenueVerificationStatus === 'success';

  const title = success ? (
    <>We need to verify your business revenue</>
  ) : (
    <>
      We were unable to <br />
      verify your revenue with the <br />
      account you selected
    </>
  );

  const subTitle = success ? (
    <>
      In order to complete your application, please
      <br /> select an option below:
    </>
  ) : (
    <>Please try a different account or upload documents:</>
  );

  return (
    <WizardPage title={title} subtext={subTitle}>
      <Stack spacing={4} divider={<Divider flexItem> Or </Divider>}>
        <MxVerifyRevenueTile />
        <DocsVerifyRevenueTile />
      </Stack>
    </WizardPage>
  );
};

export { VerifyRevenuePage };
